// Der Gemini-API-Key liegt nur noch serverseitig (api/chat.js, Vercel Serverless Function).
// Dieses Modul spricht ausschliesslich mit unserem eigenen /api/chat-Proxy.

let history = [];

const FEHLER = {
  de: {
    rateLimit: "Ich erhalte gerade zu viele Anfragen (Rate Limit). Bitte warte einen Moment und versuche es erneut.",
    allgemein: "Entschuldigung, da ist etwas schiefgelaufen. Ich kann gerade nicht antworten.",
  },
  en: {
    rateLimit: "I'm receiving too many requests right now (rate limit). Please wait a moment and try again.",
    allgemein: "Sorry, something went wrong. I can't answer right now.",
  },
};

export const startChat = async () => {
  history = [];
};

export const sendMessage = async (message, lang = "de") => {
  const fehler = FEHLER[lang] || FEHLER.de;
  try {
    const response = await fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message, history, lang }),
    });

    if (response.status === 429) {
      const data = await response.json().catch(() => ({}));
      return data.error || fehler.rateLimit;
    }
    if (!response.ok) {
      throw new Error(`Chat request failed with status ${response.status}`);
    }

    const { reply } = await response.json();
    history.push({ role: "user", parts: [{ text: message }] });
    history.push({ role: "model", parts: [{ text: reply }] });
    return reply;
  } catch (error) {
    console.error("Error sending message to chat API:", error);
    return fehler.allgemein;
  }
};
